// extracted by mini-css-extract-plugin
export var downloadLink = "dN_kC";
export var downloadText = "dN_kD";